// extracted by mini-css-extract-plugin
export default {"container":"secureBootHub_container__dsVCS","deviceCard":"secureBootHub_deviceCard__X68ig","tableWrapper":"secureBootHub_tableWrapper__lbIKr"};